import {MerchantDetails} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/merchant_info/v1/service.types';
import React, {ComponentType, FC, useState} from 'react';
import {MerchantLegalInfoWrapperHandler} from './MerchantLegalInfoWrapperHandler';

export function withMerchantLegalInfo<T>(
  InnerComponent: ComponentType<Exclude<T, 'onSoldByInfoClick'>>,
) {
  const WrappedComponent: FC<Exclude<T, 'onSoldByInfoClick'>> = props => {
    const [merchantLegalInfo, setMerchantLegalInfo] = useState<
      MerchantDetails | undefined
    >(undefined);

    const onLegalInfoClose = () => {
      setMerchantLegalInfo(undefined);
    };

    const onSoldByIconClick = (value: MerchantDetails) => {
      setMerchantLegalInfo(value);
    };

    return (
      <>
        <InnerComponent {...props} onSoldByInfoClick={onSoldByIconClick} />
        {merchantLegalInfo && (
          <MerchantLegalInfoWrapperHandler
            merchantInfo={merchantLegalInfo}
            onClose={onLegalInfoClose}
          />
        )}
      </>
    );
  };
  return WrappedComponent;
}
